import Lang from './Lang'
import Swal from 'sweetalert2'

export default class ConfirmClick {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ConfirmClick(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick)
    }

    #handleClick = async (event) => {
        event.preventDefault()

        const { isConfirmed } = await Swal.fire({
            title: this.#element.dataset.gpTitle,
            text: this.#element.dataset.gpMessage,
            icon: this.#element.dataset.gpIcon ?? 'info',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText:
                '<i class="bi bi-hand-thumbs-up me-2"></i>' + Lang.get('general.confirm'),
            cancelButtonText:
                '<i class="bi bi-hand-thumbs-down me-2"></i>' + Lang.get('general.cancel'),
        })

        if (isConfirmed) {
            window.location = this.#element.href
        }
    }
}
